import { AppContextProps } from '@wap-client/core'

export enum AkivaType {
  Duration = 'duration',
  Gallery = 'gallery',
  GlobalSearch = 'global-search',
  HotelSearch = 'hotel-search',
  HotelView = 'hotel-view',
  Hotels = 'hotels',
  Instagram = 'instagram',
  Like = 'like',
  Main = 'main',
  Menu = 'menu',
  MostPopular = 'most-popular',
  Performance = 'performance',
  SliderMore = 'slider-more',
  SliderMoreHotel = 'slider-more-hotel',
  Social = 'social-media',
  SubSite = 'sub-site',
  Survey = 'survey',
  UrlView = 'url-view',
  View = 'view',
}

export interface AkivaProps {
  app: AppContextProps
  type: AkivaType
  referrer?: string
  data?: object
}

export interface AkivaRequest {
  page:
    | AkivaPage
    | AkivaView
    | AkivaDuration
    | AkivaPerformance
    | AkivaGlobalSearch
  type: AkivaType
  client: AkivaClient
  trackingCode: string
}

export interface AkivaPage {
  id: string
  referrer?: string
  parameters: AkivaParameters
}

export interface AkivaParameters {
  fp: string
  lang: string
  path: string
  sessionStartAt: string
  userLocalAt: string
}

export interface AkivaClient {
  sessionId: string
  userId: string
  timing?: string
}

export interface AkivaViewParameters extends AkivaParameters {
  pageInitializedAt: string
}

export interface AkivaView extends AkivaPage {
  parameters: AkivaViewParameters
}

export interface AkivaPerformanceParameters extends AkivaParameters {
  contentLoadAsMilliseconds: number
  domContentLoadedEvent: number
  domProcessing: number
  networkServer: number
  timeToFirstByte: number
  totalPageLoadAsSeconds: number
  pageInitializedAt: string
}

export interface RequestedFile {
  name: string
  domain: string
  transferSize: number
  loadTime: string
  startTime: number
  responseEnd: number
  initiatorType: string
}

export interface SearchResult {
  domain: string
  url: string
  title: string
}

export interface AkivaPerformance extends AkivaPage {
  requestedFiles: RequestedFile[]
  parameters: AkivaPerformanceParameters
}

export interface AkivaDurationParameters extends AkivaParameters {
  durationAsSeconds: number
  pageExitAt: string
  pageInitializedAt: string
}

export interface AkivaDuration extends AkivaPage {
  parameters: AkivaDurationParameters
}

export interface AkivaGlobalSearchParameters extends AkivaParameters {
  fullPath: string
  searchValue: string
  searchResponseTime: number
  searchedAt: string
}

export interface AkivaGlobalSearch extends AkivaPage {
  resultList: SearchResult[]
  clickedResult: SearchResult | null
  parameters: AkivaGlobalSearchParameters
}

export interface AkivaData {
  fullPath: string
}
